const serviceTypeBrandcodes = {
  Eurostar: 'Eurostar',
  SNCF: 'SNCF',
  Lyria: 'Lyria',
  INOUI: 'TGV INOUI'
};

export default serviceTypeBrandcodes;
